var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanoeFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 86.1,
    cy: 36,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,120c-2,2.7-4.1,5.5-4.1,8.5V144h2.7v-15.5c0-2.1,1.8-4.6,3.6-6.9c1-1.3,2-2.7,2.8-4.1c0.8,1.4,1.8,2.7,2.8,4.1 c1.8,2.3,3.6,4.8,3.6,6.9V144h2.7v-15.5c0-3-2.1-5.8-4.1-8.5c-1.4-1.9-2.8-3.8-3.4-5.5H144v-2.7h-21.8V82.1 c2.2-0.6,3.7-2.6,3.7-4.9s-1.6-4.3-3.7-4.9V41.9l2.2-2.2c2-2,2-5.3,0-7.3s-5.3-2-7.3,0l-16.5,16.5H77.1c-1.3,0-2.6,0.5-3.6,1.5 L41.6,82.3h32.7l11.9-11.9l10.4,10.4c0.9,0.9,2.2,1.5,3.6,1.5h19.2v29.5H86.1V92.6c0-2.8-2.3-5.1-5.1-5.1H51l0,0H36.4l-24.4,24.4H0 v2.7h119.2C118.7,116.3,117.3,118.2,115.9,120z M102.4,72L89.6,59.1h13.3c1.6,0,3-0.7,3.9-1.8l12.7-12.7V72H102.4z M75.9,111.8 H26.6l14.1-14.1h35.2V111.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanoeFlat);
export default __webpack_public_path__ + "static/media/canoeFlat.4c33c4cc22045cd4d70eefc23be6e19e.svg";
export { ForwardRef as ReactComponent };